import {useFlag as useReflagFlag} from '@reflag/react-sdk';

const FLAGS = {
  CAREGIVER_READS_FROM_LOOM: 'caregiver-loom-reads',
  JOB_READS_FROM_LOOM: 'job-loom-reads',
  CLIENT_READS_FROM_LOOM: 'client-loom-reads',
  SCHEDULE_READS_FROM_LOOM: 'schedule-loom-reads',
};

export const useFlag = (flag) => useReflagFlag(flag);

export default FLAGS;
